import Vue from "vue";
import router from "@/router";
import sha512 from "js-sha512";
import CryptoJS from 'crypto-js';
import dayjs from "dayjs";

export function makeSgin() {
    var text = dayjs().format("YYYY-MM-DD HH:mm");
    return sha512(text);
}

/**
 * 获取uuid
 */
export function getUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
            16
        );
    });
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
    return (
        JSON.parse(sessionStorage.getItem("permissions") || "[]").indexOf(key) !==
        -1 || false
    );
}

/**
 * 获取字典值
 * 适用于 通过 gender:1 显示 男
 * @param type
 * @param code
 * 如 getDictValue ('gender', '1') == 男
 */
export function getDictValue(type, code) {
    this.$http({
        url: this.$http.adornUrl("sys/dict/dictValue"),
        method: "get",
        params: this.$http.adornParams({
            type: type,
            code: code,
        }),
    }).then(({data}) => {
        return data.data;
    });
}

export function getSysDictVal(type, code) {
    let value = sessionStorage.getItem("dict" + type + code);
    return value;
}

/**
 * 获取字典列表
 * 适用于 下拉框选择
 * @param type
 * @param code
 * 如 getDicts ('gender')
 */
export function getDicts(type) {
    return this.$http({
        url: this.$http.adornUrl("/sys/dict/listByType"),
        method: "get",
        params: this.$http.adornParams({
            type: type,
        }),
    });
}

export function aesDecrypt(word, keyStr) {
    let date = new Date()
    let dataStr = dateFormat("ddHHmm",date);
    keyStr = keyStr + dataStr;
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    let decryptStr = CryptoJS.enc.Utf8.stringify(decrypt).toString();
    return decryptStr;
}

export function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "YY": date.getFullYear().toString(),        // 年
        "MM": (date.getMonth() + 1).toString(),     // 月
        "dd": date.getDate().toString(),            // 日
        "HH": date.getHours().toString(),           // 时
        "mm": date.getMinutes().toString(),         // 分
        "ss": date.getSeconds().toString()          // 秒
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = "id", pid = "parentId") {
    var res = [];
    var temp = {};
    for (var i = 0; i < data.length; i++) {
        temp[data[i][id]] = data[i];
    }
    for (var k = 0; k < data.length; k++) {
        if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
            if (!temp[data[k][pid]]["children"]) {
                temp[data[k][pid]]["children"] = [];
            }
            if (!temp[data[k][pid]]["_level"]) {
                temp[data[k][pid]]["_level"] = 1;
            }
            data[k]["_level"] = temp[data[k][pid]]._level + 1;
            temp[data[k][pid]]["children"].push(data[k]);
        } else {
            res.push(data[k]);
        }
    }
    return res;
}


export function getLoginToken() {
    return  Vue.cookie.get("token");
}

/**
 * 是否机构管理员
 * @returns {boolean}
 */
export function manageOrgIdFlag() {
    try {
        let orgId =  JSON.parse(this.$cookie.get("loginUser")).orgId;
        return orgId === '2cee6ec71ed84a979f36db6529bc1328';
    }catch (e) {
        this.$message({
            message: "token过期请重新登录！",
            type: "error",
        });
    }
}

/**
 * 获取当前机构id
 * @returns {*}
 */
export function geLoginOrg() {
    try {
        let orgId =  JSON.parse(Vue.cookie.get("loginUser")).orgId
        return orgId;
    }catch (e) {
        this.$message({
            message: "token过期请重新登录！",
            type: "error",
        });
    }

}

/**
 * 构建图片名称
 * @returns {*}
 */
export function buildFileName( fileName) {
    let myDate = new Date();
    let today = (myDate.getMonth() + 1) + "" +myDate.getDate()+ "" + myDate.getHours()+ "" + myDate.getMinutes()+ "" + myDate.getSeconds();
    fileName = fileName.substring(0, fileName.indexOf(".")) + "_" + today + fileName.substring(fileName.indexOf("."));
    return fileName;
}
function uuid() {
    var s = [];
    var hexDigits = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    for (var i = 0; i < 8; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] ;

    var uuid = s.join("");
    return uuid;
}

/**
 * 构建图片文件夹
 * @returns {*}
 */
export function buildFolder(path) {
    let orgCode =  JSON.parse(Vue.cookie.get("loginUser")).orgCode;
    if(orgCode === ""){
        orgCode = "defaultOrg";
    }
    path = "/" + orgCode + path;
    let myDate = new Date();
    let today = path +  "/" + myDate.getFullYear() + "" + (myDate.getMonth() + 1) + "" +myDate.getDate() + "/" ;
    today += uuid(6, 8) +"/";
    return today;
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
    Vue.cookie.delete("token");
    Vue.cookie.delete("loginUser")
    router.options.isAddDynamicMenuRoutes = false;
}

